import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import {
  getAdditionalQuestions,
  isFieldRequired,
} from '@app/forms/subscription/services/utile';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const { sessionConsultant } = option || {};
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        privateEquityInvestmentAmount: [
          entity?.parameters?.privateEquityInvestmentAmount || null,
          Validators.required,
        ],
        privateEquityReductionAmount: [
          entity?.parameters?.privateEquityReductionAmount || null,
          sessionConsultant &&
          isFieldRequired(
            parameters,
            CompanyFieldType.PRIVATE_EQUITY_REDUCTION_AMOUNT,
          )
            ? Validators.required
            : Validators.nullValidator,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  dispalyQuestion(parameters: Parameters, type: any) {
    return getAdditionalQuestions(parameters, type);
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
